import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-revelation-today-uid',
  templateUrl: './revelation-today-uid.component.html',
  styleUrls: ['./revelation-today-uid.component.css']
})
export class RevelationTodayUidComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
